(() => {
  const init = root => {
    if (root.dataset.refreshReady) return;
    root.dataset.refreshReady = 'true';
    const reviews = [...root.querySelectorAll('[data-mini-review]')];
    let current = 0;
    const showReview = step => {
      current = (current + step + reviews.length) % reviews.length;
      reviews.forEach((review, index) => { review.hidden = index !== current; });
      root.querySelector('[data-mini-position]').textContent = `${current + 1} / ${reviews.length}`;
    };
    root.querySelector('[data-mini-prev]').addEventListener('click', () => showReview(-1));
    root.querySelector('[data-mini-next]').addEventListener('click', () => showReview(1));
    const rail = root.querySelector('[data-review-gallery]');
    const cards = [...rail.querySelectorAll('.tlf-review')];
    const previous = root.querySelector('[data-reviews-prev]');
    const next = root.querySelector('[data-reviews-next]');
    const sync = () => {
      previous.disabled = rail.scrollLeft < 2;
      next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
    };
    const move = direction => {
      const distance = cards[1] ? cards[1].offsetLeft - cards[0].offsetLeft : rail.clientWidth;
      rail.scrollBy({left: direction * distance, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    };
    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    rail.addEventListener('scroll', sync, {passive: true});
    new ResizeObserver(sync).observe(rail);
    rail.addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1);
    });
    sync();
  };
  document.querySelectorAll('[data-editorial-refresh]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-editorial-refresh]').forEach(init));
})();
